// extracted by mini-css-extract-plugin
export default {"tutorialBG":"TutorialStyles_tutorialBG__bAYSK","show":"TutorialStyles_show__pH8uL","tutorial":"TutorialStyles_tutorial__Ysqph","skipCount":"TutorialStyles_skipCount__jbbQV"};